import React from 'react';
import Sweeper from '../../container/Sweeper';

const App = props => (
  <Sweeper/>
);

export default App;
